"use client";

import React from "react";
import { Instagram, Heart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col items-center md:items-start gap-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted/20 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col items-center md:items-start gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-foreground transition-colors duration-300 text-sm tracking-wide">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="dark bg-background text-foreground py-20 px-6 border-t border-border/10">
      <div className="max-w-6xl mx-auto flex flex-col items-center">
        {}
        <div className="mb-16">
          <Link to="/" className="inline-block transition-opacity hover:opacity-80">
            <WvcLogo className="h-16 w-auto text-foreground" />
          </Link>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 w-full text-center md:text-left">
          
          {}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-default text-sm font-semibold tracking-widest uppercase text-foreground/90 mb-6">
              Details
            </h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col items-center">
            <h3 className="font-default text-sm font-semibold tracking-widest uppercase text-foreground/90 mb-6">
              Follow Us
            </h3>
            <div className="flex gap-4">
              <Link to="#" className="p-3 rounded-lg bg-muted/10 hover:bg-muted/30 transition-colors text-muted-foreground hover:text-foreground" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </Link>
              <Link to="#" className="p-3 rounded-lg bg-muted/10 hover:bg-muted/30 transition-colors text-muted-foreground hover:text-foreground" aria-label="Pinterest">
                <Heart className="w-5 h-5" />
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col items-center md:items-end">
            <h3 className="font-default text-sm font-semibold tracking-widest uppercase text-foreground/90 mb-6">
              Share the Love
            </h3>
            <p className="font-serif text-2xl md:text-3xl text-primary/90 italic tracking-wide">
              #AnthonyLilyForever
            </p>
          </div>
        </div>

        {}
        <div className="mt-20 pt-8 border-t border-border/10 w-full text-center text-xs tracking-wider text-muted-foreground/60 uppercase">
          <p>&copy; {new Date().getFullYear()} Anthony & Lily's celebration. All rights reserved.</p>
        </div>
      </div>
    </section>;
}